import request from "@/router/axios";

// 查询消息列表
export const getAllMessage = (current, size, params, search) => {
  return request({
    url: `/api/blade-loanMessage/loanMessage/list`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};


//export
export const exportLoanLending = () => {
  return request({
    url: `/api/blade-loanLending/loanLending/export`,
    method: "get",
  });
};
